// use-time@0.0.1 - 2020-06-10T19:18:35.780Z
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react'], factory) :
  (global = global || self, factory(global.useTime = {}, global.React));
}(this, (function (exports, react) { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var noop = function noop() {};

  var mockWindow = {
    setInterval: noop,
    clearInterval: noop
  };
  /**
   * @returns {Window}
   */

  function getWindow() {
    if (typeof window !== "undefined") return window;
    return mockWindow;
  }

  var TIME_UNITS = {
    ms: {
      unit: 1,
      names: ["ms", "millisecond", "milliseconds"]
    },
    s: {
      unit: 1000,
      names: ["s", "seconds", "sec", "second"]
    },
    m: {
      unit: 1000 * 60,
      names: ["m", "min", "minute", "minutes"]
    },
    h: {
      unit: 1000 * 60 * 60,
      names: ["h", "hour", "hours"]
    }
  };
  var SUPPORT_TIME_UNIT_NAMES = flatten(Object.values(TIME_UNITS).map(function (_ref) {
    var names = _ref.names;
    return names;
  }));
  /**
   * `when`:
   *  - A function that takes Date object as parameter and returns boolean value
   * @param {{when: Function|number, [delay]: number}} args
   * @returns {number} the number of milliseconds returned by `Date#getTime()`
   */

  function useTime() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref2 = args || {},
        range = _ref2.range;

    var interval = parseInterval(args.interval || 1000);
    var initialTime = react.useMemo(function () {
      return Date.now();
    }, []);

    var _useState = react.useState(function () {
      return Date.now();
    }),
        _useState2 = _slicedToArray(_useState, 2),
        time = _useState2[0],
        setTime = _useState2[1];

    react.useEffect(function () {
      var intervalId = getWindow().setInterval(function () {
        var now = Date.now();

        if (!range) {
          setTime(now);
        } else if (typeof range === "string") {
          var _parseTimeQueryString = parseTimeQueryString(range),
              from = _parseTimeQueryString.from,
              to = _parseTimeQueryString.to,
              error = _parseTimeQueryString.error;

          if (error) console.error(new Error(error));else {
            if (from <= now && now <= to) {
              setTime({
                from: from,
                to: to
              });
            }
          }
          setTime();
        } else if (typeof range === "function") {
          if (range(now, initialTime)) {
            setTime(now);
          }
        } else {
          console.error(new Error("Unsupport type of 'range': ".concat(_typeof(range), ".")));
        }
      }, interval);
      return function () {
        getWindow().clearInterval(intervalId);
      };
    }, [initialTime, interval, range]);
    return [time, initialTime, time - initialTime];
  }
  function parseInterval(interval) {
    if (typeof interval === "number") {
      return interval;
    } else if (typeof interval === "string") {
      var _interval$split = interval.split(/\s+/),
          _interval$split2 = _slicedToArray(_interval$split, 2),
          num = _interval$split2[0],
          unitName = _interval$split2[1];

      return getMilliseconds(num, unitName);
    }

    throw new Error("Unsupoprt interval. Found: ".concat(interval));
  }
  /**
   * @example
   *  parseTimeQueryString('last 5 minutes')
   * @param {string} timeQueryString
   * @returns {{from: number, to: number, error: string}}
   */

  function parseTimeQueryString(timeQueryString) {
    var _timeQueryString$spli = timeQueryString.split(/\s+/),
        _timeQueryString$spli2 = _slicedToArray(_timeQueryString$spli, 3),
        last = _timeQueryString$spli2[0],
        numStr = _timeQueryString$spli2[1],
        unitName = _timeQueryString$spli2[2];

    var num = parseInt(numStr);

    if (last !== "last") {
      return {
        error: "Invalid time range query string. Must start with \"last\". Found: ".concat(last)
      };
    }

    if (isNaN(num)) {
      return {
        error: "Invalid time range query string at ".concat(numStr, ". Expect a number")
      };
    }

    if (!SUPPORT_TIME_UNIT_NAMES.includes(unitName)) {
      return {
        error: "Unrecognized time range unit ".concat(unitName, ". Must be one of ").concat(SUPPORT_TIME_UNIT_NAMES.join(", "))
      };
    }

    var milliseconds = getMilliseconds(num, unitName);
    var to = Date.now();
    var from = to - milliseconds;
    return {
      from: from,
      to: to
    };
  }

  function getMilliseconds(num, unitName) {
    var unitDefinition = Object.values(TIME_UNITS).find(function (unitDefinition) {
      return unitDefinition.names.includes(unitName);
    });
    return unitDefinition.unit * num;
  }

  function flatten(array) {
    return [].concat.apply([], array);
  }

  exports.parseInterval = parseInterval;
  exports.parseTimeQueryString = parseTimeQueryString;
  exports.useTime = useTime;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
